import * as getters from './getters';

const state = {
  status: [
    {
      value: 1,
      label: '公開',
    },
    {
      value: 0,
      label: '非公開',
    },
  ],
  article_type: [
    {
      value: 1,
      label: '特集',
    },
    {
      value: 2,
      label: '連載',
    },
  ],
  permission: [
    {
      value: 1,
      label: '無料',
    },
    {
      value: 2,
      label: '会員',
    },
    {
      value: 3,
      label: '有料',
    },
  ],
  target: [
    {
      value: 'self',
      label: 'リンクを別タブで表示しない',
    },
    {
      value: 'blank',
      label: 'リンクを別タブで表示する',
    },
  ],
};

export default {
  state,
  getters,
};
